// extracted by mini-css-extract-plugin
module.exports = {"range":"score-range_range__2VNng","rangeValue":"score-range_rangeValue__3f0p7","rangeDescription":"score-range_rangeDescription__2sZVi"};